import { createLucideIcon } from 'lucide-react';
export const SyncIcon = createLucideIcon('sync', [
  [
    'path',
    {
      d: 'M19.4213 15C19.4213 15 17.2451 20.0317 11.9936 20.1068C6.7421 20.1819 4.4372 16.2145 4.4372 16.2145',
      key: 'mhokp5',
    },
  ],
  [
    'path',
    {
      d: 'M19.5 8H15',
      key: 'oijngw',
    },
  ],
  [
    'path',
    {
      d: 'M19.5 8V3.5',
      key: '1nr300',
    },
  ],
  [
    'path',
    {
      d: 'M4.4372 16.2145L4.5015 20.714',
      key: '1ywmf7',
    },
  ],
  [
    'path',
    {
      d: 'M4.4372 16.2145L8.9367 16.1501',
      key: 'qcqbtl',
    },
  ],
  [
    'path',
    {
      d: 'M4.5 9C4.5 9 6.748 4 12 4C17.252 4 19.5 8 19.5 8',
      key: 'z86ti6',
    },
  ],
]);
